import { render } from "./TrendingHistory.vue?vue&type=template&id=5e4b878a&scoped=true"
import script from "./TrendingHistory.vue?vue&type=script&lang=js"
export * from "./TrendingHistory.vue?vue&type=script&lang=js"

import "./TrendingHistory.vue?vue&type=style&index=0&id=5e4b878a&lang=scss&scoped=true"
import "./TrendingHistory.vue?vue&type=style&index=1&id=5e4b878a&scoped=true&lang=css"
import "./TrendingHistory.vue?vue&type=style&index=2&id=5e4b878a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4b878a"]])

export default __exports__